import React from "react";

const RequestError = ({msg}) => <div className="alert alert-danger" role="alert">{`Error ${msg.status}: ${msg.statusText}`}</div>
export default RequestError;
